import React from 'react';
import PropTypes from 'prop-types';
import { StyledTHead } from './style';

const THead = ({ children, ...props }) => (
  <StyledTHead {...props}>{children}</StyledTHead>
);

THead.propTypes = {
  children: PropTypes.node.isRequired
};

export default THead;
